'use client';

import { __styles, mergeClasses } from '@griffel/react';
import { useDrawerHeaderStyles_unstable } from '@fluentui/react-drawer';
export const navDrawerHeaderClassNames = {
  root: 'fui-NavDrawerHeader'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    jrapky: 0,
    Frg6f3: 0,
    t21cq0: 0,
    B6of3ja: 0,
    B74szlk: "f1r2n0t9",
    B1hrpyx: "f80d8h0",
    Dbcxam: 0,
    rjzwhg: 0,
    Bblux5w: "fesrmp8"
  }
}, {
  d: [[".f1r2n0t9{margin:unset;}", {
    p: -1
  }], ".f80d8h0{-webkit-padding-start:14px;padding-inline-start:14px;}", [".fesrmp8{padding-block:5px;}", {
    p: -1
  }]]
});
/**
 * Apply styling to the NavDrawerHeader slots based on the state
 */
export const useNavDrawerHeaderStyles_unstable = state => {
  'use no memo';

  useDrawerHeaderStyles_unstable(state);
  const styles = useStyles();
  state.root.className = mergeClasses(navDrawerHeaderClassNames.root, styles.root, state.root.className);
  return state;
};